module.exports = __webpack_public_path__ + "static/media/waiting_list_white.c548a543.svg";